module.exports = __webpack_public_path__ + "img/kj1.9d6d3d64.png";